// 30 signature dishes — each becomes /menu/ghaza/<slug>. Real Persian food
// content with history, ingredients, serving style, and pairing notes.
// No invented prices or nutrition data per the project rules.
export const DISHES = [
    {
        slug: 'chelo-kabab-koobideh',
        name: 'چلوکباب کوبیده',
        nameEn: 'Chelo Kabab Koobideh',
        category: 'kabab',
        short: 'کباب کوبیده دست‌چرخ همراه برنج زعفرانی، گوجه کبابی و کره — پرسفارش‌ترین غذای منوی آرشه.',
        description: 'چلوکباب کوبیده غذای ملی ایران شناخته می‌شود — مخلوطی از گوشت چرخ‌کرده گوسفندی و گوساله که با پیاز رنده، نمک، فلفل و مقدار کمی زرده تخم‌مرغ ورز داده شده و روی سیخ‌های پهن گذاشته می‌شود. کباب روی آتش زغال طبیعی گریل می‌شود تا بیرون آن قهوه‌ای و درون آن آبدار باقی بماند.\n\n' +
            'در آشپزخانه آرشه، گوشت روزانه و تازه تهیه می‌شود. مخلوط گوشت پس از ورز دادن، حداقل یک ساعت در یخچال استراحت می‌کند تا ادویه‌ها به‌خوبی جذب شوند. برنج چلو نیز جداگانه با روش ایرانی (آبکش) پخته می‌شود و در پایان با زعفران رنگ‌آمیزی می‌شود.',
        ingredients: ['گوشت چرخ‌کرده گوسفندی و گوساله', 'پیاز رنده', 'زرده تخم‌مرغ', 'نمک و فلفل', 'برنج ایرانی', 'زعفران', 'کره حیوانی'],
        servingStyle: 'دو سیخ کباب کوبیده روی برنج چلو، به همراه گوجه کبابی، کره و یک لیوان دوغ.',
        pairings: ['دوغ گازدار', 'سالاد شیرازی', 'ترشی هفت‌بیجار', 'نان سنگک گرم'],
        origin: 'تهران و سراسر ایران',
        imageId: 'photo-1555939594-58d7cb561ad1',
        related: ['chelo-kabab-barg', 'jujeh-kabab', 'kabab-bakhtiari', 'kashk-bademjan'],
    },
    {
        slug: 'chelo-kabab-barg',
        name: 'چلو کباب برگ',
        nameEn: 'Chelo Kabab Barg',
        category: 'kabab',
        short: 'فیله گوساله مارینه شده و گریل‌شده روی زغال، همراه برنج زعفرانی و کره.',
        description: 'کباب برگ یکی از پرتجمل‌ترین کبابهای ایرانی است — تکه‌های نازک فیله گوساله که شب قبل با پیاز، نمک، فلفل و عصاره لیمو مارینه می‌شوند. این مارینه باعث می‌شود گوشت در زمان گریل، بافت نرم و خوش‌طعم پیدا کند.\n\n' +
            'در آرشه، کباب برگ به سفارش جلسات کاری و میهمانی‌های ویژه آماده می‌شود. زمان پخت آن به دقت کنترل می‌شود تا گوشت نه خام بماند نه خشک شود. ارائه‌ی نهایی روی بستر برنج زعفرانی با گوجه کبابی و فلفل سبز گریل‌شده.',
        ingredients: ['فیله گوساله', 'پیاز', 'لیمو', 'زعفران', 'برنج ایرانی', 'کره', 'گوجه و فلفل سبز'],
        servingStyle: 'یک سیخ کباب برگ روی برنج چلو، با گوجه و فلفل گریل.',
        pairings: ['دوغ', 'سالاد فصل', 'نان سنگک', 'ماست موسیر'],
        origin: 'ایران',
        imageId: 'photo-1555939594-58d7cb561ad1',
        related: ['chelo-kabab-koobideh', 'jujeh-kabab', 'kabab-soltani', 'baghali-polo-mahiche'],
    },
    {
        slug: 'jujeh-kabab',
        name: 'جوجه‌کباب زعفرانی',
        nameEn: 'Jujeh Kabab',
        category: 'kabab',
        short: 'تکه‌های سینه مرغ مارینه با زعفران و آبلیمو، گریل‌شده روی زغال.',
        description: 'جوجه‌کباب از محبوب‌ترین کباب‌های ایرانی است که در دهه‌های اخیر جای ویژه‌ای در منوی رستوران‌ها پیدا کرده است. تکه‌های سینه مرغ یا ران بدون استخوان، با مخلوط زعفران دم‌کرده، پیاز رنده، آبلیمو و روغن زیتون مارینه می‌شوند.\n\n' +
            'در آرشه، جوجه‌کباب با مرغ تازه تهیه می‌شود و مارینه آن حداقل ۶ ساعت در یخچال نگه‌داری می‌شود تا طعم زعفران به‌خوبی به گوشت برسد. گریل روی آتش زغال انجام می‌شود و در پایان با کره و زعفران بیشتر تزئین می‌شود.',
        ingredients: ['سینه یا ران مرغ', 'زعفران', 'آبلیمو', 'پیاز', 'روغن زیتون', 'برنج چلو', 'کره'],
        servingStyle: 'دو سیخ جوجه‌کباب روی برنج چلو، با گوجه کبابی و فلفل.',
        pairings: ['دوغ', 'سالاد سزار', 'نان لواش', 'ماست و خیار'],
        imageId: 'photo-1467003909585-2f8a72700288',
        related: ['chelo-kabab-koobideh', 'kabab-bakhtiari', 'jujeh-torsh', 'zereshk-polo'],
    },
    {
        slug: 'kabab-bakhtiari',
        name: 'کباب بختیاری',
        nameEn: 'Kabab Bakhtiari',
        category: 'kabab',
        short: 'ترکیبی از کباب برگ و جوجه‌کباب در یک سیخ — انتخابی برای تنوع‌طلبان.',
        description: 'کباب بختیاری ابتکار رستوران‌داران ایرانی است — تکه‌های فیله گوساله و جوجه‌کباب یک‌درمیان روی یک سیخ گذاشته می‌شوند. این سبک، تنوع طعمی و بصری ویژه‌ای به سیخ می‌دهد.\n\n' +
            'در آرشه، هر دو نوع گوشت با مارینه اختصاصی خود آماده می‌شوند و در زمان گریل، دما به‌گونه‌ای تنظیم می‌شود که هم گوشت قرمز و هم مرغ به‌اندازه پخته شوند. این غذا انتخابی محبوب برای جلسات شام شرکت‌هاست.',
        ingredients: ['فیله گوساله', 'سینه مرغ', 'زعفران', 'پیاز', 'برنج چلو', 'کره'],
        servingStyle: 'یک سیخ بختیاری روی برنج چلو، با گوجه و فلفل.',
        pairings: ['دوغ', 'سالاد شیرازی', 'نان سنگک', 'ترشی'],
        imageId: 'photo-1555939594-58d7cb561ad1',
        related: ['chelo-kabab-barg', 'jujeh-kabab', 'kabab-soltani', 'chelo-kabab-koobideh'],
    },
    {
        slug: 'kabab-soltani',
        name: 'کباب سلطانی',
        nameEn: 'Kabab Soltani',
        category: 'kabab',
        short: 'یک سیخ کباب برگ و یک سیخ کباب کوبیده — انتخاب مهمانی‌های مجلل.',
        description: 'کباب سلطانی پرتجمل‌ترین گزینه از خانواده کباب‌های ایرانی است — یک سیخ کباب برگ از فیله گوساله و یک سیخ کباب کوبیده دست‌چرخ، در یک پرس. این انتخاب معمولاً برای میهمانی‌های ویژه و جلسات رسمی استفاده می‌شود.\n\n' +
            'در آرشه، کباب سلطانی به‌سفارش پذیرایی جلسات مدیریتی و رویدادهای ویژه تهیه می‌شود. ارائه روی بستر برنج زعفرانی فراوان، با گوجه کبابی، فلفل سبز و کره حیوانی.',
        ingredients: ['فیله گوساله', 'گوشت چرخ‌کرده', 'پیاز', 'زعفران', 'برنج چلو', 'کره حیوانی'],
        servingStyle: 'یک سیخ برگ + یک سیخ کوبیده روی برنج چلو.',
        pairings: ['دوغ گازدار', 'سالاد فصل', 'نان سنگک', 'ماست موسیر'],
        imageId: 'photo-1555939594-58d7cb561ad1',
        related: ['chelo-kabab-barg', 'chelo-kabab-koobideh', 'kabab-bakhtiari', 'baghali-polo-mahiche'],
    },
    {
        slug: 'ghormeh-sabzi',
        name: 'خورشت قورمه‌سبزی',
        nameEn: 'Ghormeh Sabzi',
        category: 'khoresht',
        short: 'یکی از محبوب‌ترین خورشت‌های ایرانی — سبزی معطر، گوشت گوسفندی، لوبیا قرمز و لیمو عمانی.',
        description: 'قورمه‌سبزی یکی از پرپرستوش‌ترین خورشت‌های ایرانی است. مخلوط سبزی قورمه (تره، جعفری، گشنیز، شنبلیله) به‌مدت طولانی سرخ می‌شود تا رنگ آن تیره شود — همین فرآیند است که طعم اصیل را به خورشت می‌دهد.\n\n' +
            'در آرشه، سبزی قورمه روزانه و تازه تهیه می‌شود. خورشت چندین ساعت روی حرارت ملایم می‌جوشد تا گوشت گوسفندی نرم شود و لوبیا قرمز نرمی مناسب پیدا کند. لیمو عمانی در ۳۰ دقیقه آخر اضافه می‌شود تا ترشی متعادل بدهد.',
        ingredients: ['سبزی قورمه (تره، جعفری، گشنیز، شنبلیله)', 'گوشت گوسفندی', 'لوبیا قرمز', 'لیمو عمانی', 'پیاز', 'زردچوبه'],
        servingStyle: 'یک کاسه خورشت قورمه‌سبزی روی برنج چلو، با ته‌دیگ نان.',
        pairings: ['ماست', 'سالاد شیرازی', 'ترشی لیته', 'نان سنگک'],
        origin: 'سراسر ایران',
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['gheymeh', 'fesenjan', 'khoresht-bademjan', 'baghali-polo-mahiche'],
    },
    {
        slug: 'gheymeh',
        name: 'خورشت قیمه',
        nameEn: 'Khoresht Gheymeh',
        category: 'khoresht',
        short: 'خورشت با گوشت تکه، لپه، گوجه، و سیب‌زمینی سرخ‌شده — کلاسیک خانگی.',
        description: 'قیمه یکی از قدیمی‌ترین خورشت‌های ایرانی است. تکه‌های گوشت گوسفندی با لپه، گوجه فرنگی و ادویه‌ها پخته می‌شوند تا رنگ نارنجی متمایز خورشت ایجاد شود.\n\n' +
            'در آرشه، قیمه به سبک خانگی پخته می‌شود — یعنی گوشت ابتدا با پیاز سرخ می‌شود، سپس لپه‌ی قبلاً پخته‌شده اضافه می‌شود، و در پایان گوجه و رب اضافه می‌شود. سیب‌زمینی‌های نازک خلالی به‌صورت جداگانه سرخ شده و روی خورشت سرو می‌شوند.',
        ingredients: ['گوشت گوسفندی تکه', 'لپه', 'گوجه فرنگی', 'پیاز', 'سیب‌زمینی', 'لیمو عمانی', 'دارچین'],
        servingStyle: 'خورشت قیمه روی برنج چلو با سیب‌زمینی سرخ‌شده و سبزی خوردن.',
        pairings: ['ماست', 'سبزی خوردن', 'ترشی هفت‌بیجار', 'نان سنگک'],
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['ghormeh-sabzi', 'fesenjan', 'gheymeh-bademjan', 'khoresht-karafs'],
    },
    {
        slug: 'fesenjan',
        name: 'خورشت فسنجان',
        nameEn: 'Fesenjan',
        category: 'khoresht',
        short: 'خورشت گردو و رب انار با مرغ یا گوشت — طعم اصیل گیلانی-مازندرانی.',
        description: 'فسنجان از قدیمی‌ترین و باشکوه‌ترین غذاهای ایرانی است. مخلوط گردوی سابیده و رب انار خانگی، با گوشت یا مرغ پخته می‌شود تا خورشتی غلیظ، شیرین-ترش و قهوه‌ای‌رنگ به‌دست آید.\n\n' +
            'در آرشه، فسنجان با گردوی تازه و رب انار طبیعی تهیه می‌شود. زمان پخت طولانی است (۳ تا ۴ ساعت) تا روغن گردو آزاد شود و خورشت غلظت مناسب پیدا کند. این خورشت معمولاً در مناسبت‌های خاص سرو می‌شود.',
        ingredients: ['گردوی سابیده', 'رب انار طبیعی', 'مرغ یا گوشت', 'پیاز', 'زعفران', 'شکر'],
        servingStyle: 'خورشت فسنجان روی برنج چلو، با خلال بادام و انار تازه.',
        pairings: ['ماست', 'سالاد فصل', 'نان سنگک', 'دوغ'],
        origin: 'گیلان و مازندران',
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['ghormeh-sabzi', 'gheymeh', 'zereshk-polo', 'morgh-zaferani'],
    },
    {
        slug: 'khoresht-bademjan',
        name: 'خورشت قیمه بادمجان',
        nameEn: 'Gheymeh Bademjan',
        category: 'khoresht',
        short: 'خورشت قیمه با بادمجان سرخ‌شده — طعمی عمیق و متعادل.',
        description: 'قیمه بادمجان واریاسیونی از خورشت قیمه است که با اضافه‌کردن بادمجان سرخ‌شده، طعمی غنی‌تر و بافتی متفاوت‌تر پیدا می‌کند. این خورشت در منوی روزانه شرکت‌ها بسیار محبوب است.\n\n' +
            'در آرشه، بادمجان‌ها ابتدا کبابی یا سرخ می‌شوند تا طعم دودی پیدا کنند، سپس به خورشت قیمه پایه اضافه می‌شوند. ۲۰ دقیقه آخر پخت با حرارت ملایم، طعم‌ها را در هم می‌جوشاند.',
        ingredients: ['گوشت گوسفندی', 'لپه', 'بادمجان', 'گوجه', 'پیاز', 'لیمو عمانی'],
        servingStyle: 'خورشت قیمه بادمجان روی برنج چلو.',
        pairings: ['ماست', 'سبزی خوردن', 'ترشی', 'نان سنگک'],
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['gheymeh', 'ghormeh-sabzi', 'kashk-bademjan', 'fesenjan'],
    },
    {
        slug: 'khoresht-karafs',
        name: 'خورشت کرفس',
        nameEn: 'Khoresht Karafs',
        category: 'khoresht',
        short: 'خورشت با کرفس تازه، گوشت گوسفندی و سبزی معطر — طعمی سبک و خانگی.',
        description: 'خورشت کرفس از خورشت‌های سنتی ایرانی است که در فصل بهار محبوبیت ویژه‌ای دارد. کرفس تازه به‌صورت تکه‌ای با گوشت و سبزی معطر (نعنا و جعفری) پخته می‌شود.\n\n' +
            'در آرشه، کرفس روزانه و تازه استفاده می‌شود. خورشت با حرارت ملایم می‌جوشد تا کرفس نرم شود اما کاملاً وا نرود. لیموی تازه در پایان اضافه می‌شود تا طعم تازه‌ای به خورشت بدهد.',
        ingredients: ['کرفس تازه', 'گوشت گوسفندی', 'نعنا', 'جعفری', 'پیاز', 'لیمو تازه'],
        servingStyle: 'خورشت کرفس روی برنج چلو.',
        pairings: ['ماست', 'سالاد فصل', 'نان سنگک', 'دوغ'],
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['ghormeh-sabzi', 'gheymeh', 'khoresht-bademjan', 'baghali-polo-mahiche'],
    },
    {
        slug: 'baghali-polo-mahiche',
        name: 'باقالی‌پلو با ماهیچه',
        nameEn: 'Baghali Polo ba Mahiche',
        category: 'polo',
        short: 'برنج معطر با باقالی و شوید، همراه ماهیچه گوسفندی نرم — تجربه‌ای ویژه.',
        description: 'باقالی‌پلو با ماهیچه یکی از باشکوه‌ترین غذاهای مهمانی ایرانی است. برنج با دانه‌های باقالی و شوید خشک یا تازه مخلوط شده و به‌روش ایرانی دم می‌شود. ماهیچه گوسفندی به‌صورت جداگانه چندین ساعت روی حرارت ملایم پخته می‌شود تا کاملاً نرم و آبدار باشد.\n\n' +
            'در آرشه، این غذا معمولاً برای جلسات ویژه و میهمانی‌های شرکت‌ها سفارش گرفته می‌شود. ماهیچه آن‌قدر نرم پخته می‌شود که با قاشق جدا می‌شود. زعفران و کره حیوانی در پایان روی غذا اضافه می‌شود.',
        ingredients: ['برنج ایرانی', 'باقالی', 'شوید', 'ماهیچه گوسفندی', 'زعفران', 'کره'],
        servingStyle: 'باقالی‌پلو در بشقاب با ماهیچه نرم در کنار.',
        pairings: ['ماست', 'سالاد فصل', 'دوغ', 'نان سنگک'],
        imageId: 'photo-1505253758473-96b7015fcd40',
        related: ['zereshk-polo', 'adas-polo', 'sabzi-polo-mahi', 'tahchin'],
    },
    {
        slug: 'zereshk-polo',
        name: 'زرشک‌پلو با مرغ',
        nameEn: 'Zereshk Polo ba Morgh',
        category: 'polo',
        short: 'برنج با زرشک ترش، خلال پسته و بادام، همراه مرغ زعفرانی.',
        description: 'زرشک‌پلو یکی از مهمانی‌ترین غذاهای ایرانی است که با زرشک ترش و دانه‌های نقره‌ای زعفران، ظاهری زیبا و طعمی متمایز دارد. مرغ معمولاً با زعفران، پیاز و لیمو پخته می‌شود تا طعم غنی‌ای پیدا کند.\n\n' +
            'در آرشه، زرشک تازه روی روغن گرم و کمی شکر تفت داده می‌شود تا براق و طلایی شود. تزئین نهایی با خلال پسته، خلال بادام و گلبرگ‌های گل سرخ خشک انجام می‌شود.',
        ingredients: ['برنج ایرانی', 'زرشک', 'زعفران', 'مرغ', 'پسته خلالی', 'بادام خلالی', 'پیاز'],
        servingStyle: 'زرشک‌پلو با مرغ تکه‌ای در کنار.',
        pairings: ['ماست', 'سالاد فصل', 'دوغ', 'نان سنگک'],
        imageId: 'photo-1505253758473-96b7015fcd40',
        related: ['baghali-polo-mahiche', 'adas-polo', 'morgh-zaferani', 'tahchin'],
    },
    {
        slug: 'adas-polo',
        name: 'عدس‌پلو',
        nameEn: 'Adas Polo',
        category: 'polo',
        short: 'برنج ایرانی با عدس، کشمش، خرما و دارچین — گزینه‌ای گیاهی و شیرین-تند.',
        description: 'عدس‌پلو یکی از قدیمی‌ترین غذاهای ایرانی است که می‌تواند هم گیاهی و هم با گوشت چرخ‌کرده سرو شود. ترکیب عدس قهوه‌ای، کشمش پلویی، خرما و دارچین، طعمی شیرین، عمیق و معطر ایجاد می‌کند.\n\n' +
            'در آرشه، نسخه گیاهی این غذا انتخاب محبوب کارمندان رژیمی و گیاه‌خواران است. عدس‌ها از قبل پخته می‌شوند تا با برنج تطابق بافتی داشته باشند. کشمش و خرما در روغن گرم تفت داده می‌شوند تا براق شوند.',
        ingredients: ['برنج ایرانی', 'عدس قهوه‌ای', 'کشمش پلویی', 'خرما', 'دارچین', 'پیاز', 'زعفران'],
        servingStyle: 'عدس‌پلو در بشقاب با تزئین کشمش و خرما.',
        pairings: ['ماست', 'سالاد', 'سبزی خوردن', 'دوغ'],
        imageId: 'photo-1505253758473-96b7015fcd40',
        related: ['baghali-polo-mahiche', 'zereshk-polo', 'tahchin', 'kalam-polo'],
    },
    {
        slug: 'tahchin',
        name: 'ته‌چین مرغ',
        nameEn: 'Tahchin Morgh',
        category: 'polo',
        short: 'کیک برنج زعفرانی با لایه ماست، تخم‌مرغ و مرغ — ته‌دیگ طلایی متمایز.',
        description: 'ته‌چین یکی از ابتکاری‌ترین غذاهای ایرانی است — مخلوط برنج، ماست، تخم‌مرغ و زعفران در قابلمه فشرده می‌شود تا یک کیک طلایی با ته‌دیگ ترد ایجاد شود. لایه‌ای از مرغ زعفرانی پخته‌شده در میانه ته‌چین قرار می‌گیرد.\n\n' +
            'در آرشه، ته‌چین به‌صورت قطعه‌ای سرو می‌شود — هر قطعه مربعی شامل لایه پایین ترد، لایه میانی مرغ و لایه بالا برنج زرد است. تزئین با زرشک، خلال پسته و بادام.',
        ingredients: ['برنج ایرانی', 'ماست چکیده', 'زرده تخم‌مرغ', 'زعفران', 'مرغ', 'زرشک', 'پسته'],
        servingStyle: 'قطعه مربعی ته‌چین تزئین‌شده با زرشک.',
        pairings: ['سالاد فصل', 'ماست', 'دوغ', 'نان سنگک'],
        imageId: 'photo-1505253758473-96b7015fcd40',
        related: ['zereshk-polo', 'baghali-polo-mahiche', 'morgh-zaferani', 'adas-polo'],
    },
    {
        slug: 'sabzi-polo-mahi',
        name: 'سبزی‌پلو با ماهی',
        nameEn: 'Sabzi Polo ba Mahi',
        category: 'polo',
        short: 'برنج با سبزی معطر و ماهی سرخ‌شده یا گریل — کلاسیک نوروزی.',
        description: 'سبزی‌پلو با ماهی غذای سنتی شب نوروز است که در طول سال هم در منوی رستوران‌های ایرانی دیده می‌شود. ترکیب سبزی معطر (شوید، گشنیز، تره) با برنج، و ماهی سفید یا قزل‌آلا کنار آن، طعمی تازه و کلاسیک می‌دهد.\n\n' +
            'در آرشه، سبزی روزانه تازه استفاده می‌شود و ماهی به‌صورت سرخ‌شده یا گریل ارائه می‌گردد. لیموی تازه و سیر تازه از همراهان ضروری این غذا هستند.',
        ingredients: ['برنج ایرانی', 'سبزی پلو (شوید، گشنیز، تره، جعفری)', 'ماهی سفید یا قزل‌آلا', 'سیر', 'لیمو', 'زعفران'],
        servingStyle: 'سبزی‌پلو در بشقاب با تکه ماهی سرخ‌شده.',
        pairings: ['ماست', 'سالاد فصل', 'لیمو تازه', 'دوغ'],
        origin: 'شب نوروز ایرانی',
        imageId: 'photo-1505253758473-96b7015fcd40',
        related: ['adas-polo', 'baghali-polo-mahiche', 'zereshk-polo', 'kalam-polo'],
    },
    {
        slug: 'kalam-polo',
        name: 'کلم‌پلو شیرازی',
        nameEn: 'Kalam Polo Shirazi',
        category: 'polo',
        short: 'برنج با کلم خرد شده، گوشت چرخ‌کرده و سبزی معطر — تخصص شیراز.',
        description: 'کلم‌پلو شیرازی یکی از غذاهای محلی استان فارس است که در سال‌های اخیر در منوی رستوران‌های تهران هم دیده می‌شود. کلم خرد شده با گوشت چرخ‌کرده تفت داده می‌شود، سپس با برنج و سبزی معطر دم می‌شود.\n\n' +
            'در آرشه، نسخه شیرازی این غذا روزانه آماده می‌شود. سبزی‌های معطر (نعنا، تره، گشنیز) و دارچین به این غذا طعم متمایزی می‌دهد.',
        ingredients: ['برنج ایرانی', 'کلم برگ', 'گوشت چرخ‌کرده', 'سبزی معطر', 'دارچین', 'زعفران'],
        servingStyle: 'کلم‌پلو در بشقاب با تزئین سبزی.',
        pairings: ['ماست', 'سالاد فصل', 'ترشی', 'دوغ'],
        origin: 'استان فارس / شیراز',
        imageId: 'photo-1505253758473-96b7015fcd40',
        related: ['adas-polo', 'baghali-polo-mahiche', 'zereshk-polo', 'morasa-polo'],
    },
    {
        slug: 'morgh-zaferani',
        name: 'مرغ زعفرانی',
        nameEn: 'Morgh Zaferani',
        category: 'persian',
        short: 'مرغ تکه‌ای پخته شده با زعفران، پیاز و لیمو — برای منوی روزانه و رژیمی.',
        description: 'مرغ زعفرانی غذای ایرانی متعادلی است — تکه‌های ران یا سینه مرغ بدون استخوان با پیاز، زعفران دم‌کرده، لیموی تازه و کمی روغن آرام پخته می‌شوند. این غذا گزینه محبوب کارمندان رژیمی است.\n\n' +
            'در آرشه، مرغ زعفرانی به‌عنوان گزینه سبک منوی روزانه طراحی شده است. زمان پخت کوتاه است و طعم زعفران به‌خوبی به گوشت مرغ نفوذ می‌کند.',
        ingredients: ['تکه‌های مرغ', 'پیاز', 'زعفران', 'لیمو تازه', 'روغن زیتون', 'نمک و فلفل'],
        servingStyle: 'مرغ زعفرانی روی برنج چلو یا با سیب‌زمینی سرخ‌شده.',
        pairings: ['سالاد سزار', 'ماست', 'سبزی خوردن', 'لیمو تازه'],
        imageId: 'photo-1467003909585-2f8a72700288',
        related: ['jujeh-kabab', 'zereshk-polo', 'tahchin', 'fesenjan'],
    },
    {
        slug: 'koofteh-tabrizi',
        name: 'کوفته تبریزی',
        nameEn: 'Koofteh Tabrizi',
        category: 'persian',
        short: 'کوفته‌های بزرگ گوشت با برنج، لپه و سبزی — تخصص آذربایجان.',
        description: 'کوفته تبریزی یکی از معروف‌ترین غذاهای محلی استان آذربایجان شرقی است. کوفته‌های گرد و بزرگ از گوشت چرخ‌کرده، برنج نیم‌پز و لپه ساخته می‌شوند که داخل آن‌ها تخم‌مرغ آب‌پز و آلوی خشک قرار دارد.\n\n' +
            'در آرشه، کوفته تبریزی به سفارش جلسات ویژه آماده می‌شود. آب‌گوشت کوفته با گوجه و رب، آرام می‌جوشد تا کوفته‌ها پخته شوند و طعم‌ها در هم بنشینند.',
        ingredients: ['گوشت چرخ‌کرده', 'برنج', 'لپه', 'تخم‌مرغ آب‌پز', 'آلوی خشک', 'سبزی معطر', 'گوجه'],
        servingStyle: 'یک کوفته بزرگ در کاسه آب‌گوشت، با نان سنگک.',
        pairings: ['نان سنگک', 'سالاد فصل', 'سبزی خوردن', 'دوغ'],
        origin: 'تبریز / آذربایجان شرقی',
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['abgoosht', 'dolmeh', 'ghormeh-sabzi', 'kashk-bademjan'],
    },
    {
        slug: 'abgoosht',
        name: 'آبگوشت (دیزی)',
        nameEn: 'Abgoosht (Dizi)',
        category: 'persian',
        short: 'غذای سنتی با گوشت، نخود، لوبیا و سیب‌زمینی — در کاسه سنگی سرو می‌شود.',
        description: 'آبگوشت یا دیزی یکی از قدیمی‌ترین غذاهای ایرانی است. ترکیب گوشت گوسفندی، نخود، لوبیا سفید، سیب‌زمینی، گوجه و ادویه‌ها چندین ساعت در دیزی سنگی می‌جوشد تا طعم‌ها در هم بنشینند.\n\n' +
            'در آرشه، آبگوشت با روش سنتی پخته می‌شود. در زمان سرو، ابتدا تیلیت (آب گوشت با نان خرد شده) خورده می‌شود، سپس مواد سفت با گوشت‌کوب کوبیده می‌شوند تا گوشت‌کوبیده آبگوشت آماده شود.',
        ingredients: ['گوشت گوسفندی', 'نخود', 'لوبیا سفید', 'سیب‌زمینی', 'گوجه', 'پیاز', 'زردچوبه'],
        servingStyle: 'دیزی سنگی با نان سنگک، سبزی خوردن و ترشی.',
        pairings: ['نان سنگک تازه', 'سبزی خوردن', 'ترشی هفت‌بیجار', 'دوغ'],
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['koofteh-tabrizi', 'kashk-bademjan', 'mirza-ghasemi', 'ash-reshteh'],
    },
    {
        slug: 'ash-reshteh',
        name: 'آش رشته',
        nameEn: 'Ash Reshteh',
        category: 'persian',
        short: 'آش غلیظ با رشته، حبوبات، سبزی و کشک — انتخاب زمستانی و ماه رمضان.',
        description: 'آش رشته یکی از آش‌های سنتی ایرانی است که در فصل‌های سرد و ماه رمضان محبوبیت ویژه‌ای دارد. ترکیب رشته آشی، حبوبات (نخود، عدس، لوبیا)، سبزی فراوان (تره، جعفری، اسفناج) و کشک، آش غلیظ و خوش‌طعمی ایجاد می‌کند.\n\n' +
            'در آرشه، آش رشته به‌عنوان گزینه پیش‌غذا یا سفارش روزانه ارائه می‌شود. تزئین با پیاز داغ، نعنا داغ، سیر داغ و کشک بیشتر در زمان سرو انجام می‌شود.',
        ingredients: ['رشته آشی', 'نخود', 'عدس', 'لوبیا', 'سبزی (تره، جعفری، اسفناج)', 'کشک', 'پیاز داغ', 'نعنا داغ'],
        servingStyle: 'کاسه آش با تزئین کشک، نعنا داغ و پیاز داغ.',
        pairings: ['نان سنگک', 'لیمو تازه', 'سبزی خوردن'],
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['abgoosht', 'kashk-bademjan', 'mirza-ghasemi', 'dolmeh'],
    },
    {
        slug: 'kashk-bademjan',
        name: 'کشک بادمجان',
        nameEn: 'Kashk-e Bademjan',
        category: 'persian',
        short: 'پیش‌غذای بادمجان کبابی با کشک، گردو و نعنا داغ — کلاسیک ایرانی.',
        description: 'کشک بادمجان یکی از پرطرفدارترین پیش‌غذاهای ایرانی است. بادمجان‌ها روی شعله مستقیم کبابی می‌شوند تا طعم دودی پیدا کنند، سپس با کشک، گردوی سابیده و سیر داغ مخلوط می‌شوند.\n\n' +
            'در آرشه، کشک بادمجان روزانه و تازه آماده می‌شود. ترکیب نهایی با نعنا داغ و پیاز داغ تزئین می‌شود و با نان سنگک گرم سرو می‌گردد.',
        ingredients: ['بادمجان', 'کشک', 'گردوی سابیده', 'سیر', 'نعنا', 'پیاز داغ', 'روغن'],
        servingStyle: 'بشقاب کشک بادمجان با نان سنگک گرم.',
        pairings: ['نان سنگک', 'سبزی خوردن', 'دوغ', 'پیش‌غذا'],
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['mirza-ghasemi', 'dolmeh', 'ash-reshteh', 'salad-shirazi'],
    },
    {
        slug: 'mirza-ghasemi',
        name: 'میرزا قاسمی',
        nameEn: 'Mirza Ghasemi',
        category: 'persian',
        short: 'بادمجان کبابی با گوجه، سیر و تخم‌مرغ — غذای محلی گیلانی.',
        description: 'میرزا قاسمی غذای محلی شناخته‌شده استان گیلان است. بادمجان روی آتش کبابی می‌شود، سپس با گوجه فرنگی پخته‌شده، سیر فراوان و تخم‌مرغ مخلوط می‌شود. طعم دودی بادمجان و سیر، امضای این غذاست.\n\n' +
            'در آرشه، میرزا قاسمی هم به‌عنوان پیش‌غذا و هم وعده اصلی سبک ارائه می‌شود. با نان سنگک گرم سرو می‌شود.',
        ingredients: ['بادمجان', 'گوجه فرنگی', 'سیر', 'تخم‌مرغ', 'زردچوبه'],
        servingStyle: 'بشقاب میرزا قاسمی با نان سنگک تازه.',
        pairings: ['نان سنگک', 'سبزی خوردن', 'لیمو تازه', 'دوغ'],
        origin: 'گیلان',
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['kashk-bademjan', 'dolmeh', 'ash-reshteh', 'salad-olviyeh'],
    },
    {
        slug: 'dolmeh',
        name: 'دلمه برگ مو',
        nameEn: 'Dolmeh',
        category: 'persian',
        short: 'برگ مو پیچیده با مخلوط برنج، گوشت چرخ‌کرده و سبزی — تخصص آذربایجان.',
        description: 'دلمه یکی از غذاهای کلاسیک منطقه آذربایجان و ایران است. مخلوط برنج نیم‌پز، گوشت چرخ‌کرده و سبزی معطر در برگ‌های مو یا کلم پیچیده می‌شود، سپس در آب‌گوشت آرام می‌جوشد.\n\n' +
            'در آرشه، دلمه با برگ مو تازه (در فصل) یا برگ مو نمکی (در طول سال) آماده می‌شود. سرو آن با ماست و آب‌لیمو همراه است.',
        ingredients: ['برگ مو', 'برنج', 'گوشت چرخ‌کرده', 'سبزی معطر (نعنا، تره، شوید)', 'پیاز', 'گوجه'],
        servingStyle: 'چند عدد دلمه در بشقاب با ماست.',
        pairings: ['ماست', 'نان سنگک', 'لیمو تازه', 'دوغ'],
        origin: 'آذربایجان / ترکیه و قفقاز',
        imageId: 'photo-1547928576-b822bc410bdf',
        related: ['koofteh-tabrizi', 'kashk-bademjan', 'mirza-ghasemi', 'abgoosht'],
    },
    {
        slug: 'pasta-alfredo',
        name: 'پاستا آلفردو مرغ',
        nameEn: 'Chicken Alfredo Pasta',
        category: 'international',
        short: 'پاستا فتوچینی با سس خامه‌ای آلفردو و تکه‌های مرغ گریل.',
        description: 'پاستا آلفردو یکی از محبوب‌ترین غذاهای فرنگی در منوی شرکت‌های ایرانی است. سس خامه‌ای آلفردو با خامه، کره، پنیر پارمزان و سیر تهیه می‌شود — ترکیبی غنی و خوش‌طعم.\n\n' +
            'در آرشه، پاستا آلفردو با پاستای فتوچینی آماده می‌شود. تکه‌های مرغ به‌صورت جداگانه گریل می‌شوند و در پایان روی پاستا قرار می‌گیرند. تزئین با جعفری تازه و فلفل سیاه.',
        ingredients: ['پاستا فتوچینی', 'سینه مرغ', 'خامه', 'کره', 'پنیر پارمزان', 'سیر', 'جعفری'],
        servingStyle: 'یک بشقاب پاستا با مرغ گریل روی آن.',
        pairings: ['سالاد سزار', 'نان سیر', 'آب نوشیدنی'],
        origin: 'ایتالیا',
        imageId: 'photo-1473093295043-cdd812d0e601',
        related: ['lasagna', 'pasta-bolognese', 'caesar-salad', 'pizza-margherita'],
    },
    {
        slug: 'pasta-bolognese',
        name: 'پاستا بولونیز',
        nameEn: 'Pasta Bolognese',
        category: 'international',
        short: 'پاستا اسپاگتی با سس گوشت چرخ‌کرده، گوجه و گیاهان معطر.',
        description: 'پاستا بولونیز یکی از کلاسیک‌ترین غذاهای ایتالیایی است. سس گوشت با گوشت چرخ‌کرده، گوجه‌فرنگی، هویج، کرفس و گیاهان معطر (ریحان، آویشن، برگ بو) ساعت‌ها روی حرارت ملایم می‌جوشد.\n\n' +
            'در آرشه، نسخه بولونیز با گوشت چرخ‌کرده گوساله تهیه می‌شود. سس حداقل ۲ ساعت می‌جوشد تا غلظت و طعم مناسب پیدا کند.',
        ingredients: ['پاستا اسپاگتی', 'گوشت چرخ‌کرده', 'گوجه فرنگی', 'هویج', 'کرفس', 'پیاز', 'ریحان'],
        servingStyle: 'پاستا اسپاگتی با سس بولونیز، تزئین با پنیر پارمزان.',
        pairings: ['سالاد ایتالیایی', 'نان سیر', 'نوشیدنی سرد'],
        origin: 'بلونیا / ایتالیا',
        imageId: 'photo-1473093295043-cdd812d0e601',
        related: ['pasta-alfredo', 'lasagna', 'pizza-margherita', 'caesar-salad'],
    },
    {
        slug: 'lasagna',
        name: 'لازانیا گوشت',
        nameEn: 'Beef Lasagna',
        category: 'international',
        short: 'لایه‌های پاستا با گوشت چرخ‌کرده، سس گوجه و پنیر موزارلا.',
        description: 'لازانیا یکی از محبوب‌ترین غذاهای ایتالیایی است که در منوی شرکت‌های ایرانی هم جایگاه ویژه دارد. ورق‌های پاستا با لایه‌های گوشت چرخ‌کرده، سس گوجه، سس بشامل و پنیر موزارلا در ظرف فر چیده می‌شوند.\n\n' +
            'در آرشه، لازانیا به‌صورت پرسی آماده می‌شود — هر پرس در ظرف کوچک منفرد. زمان پخت حدود ۳۰ تا ۴۰ دقیقه در فر است تا روی آن طلایی شود.',
        ingredients: ['ورق‌های لازانیا', 'گوشت چرخ‌کرده', 'سس گوجه', 'سس بشامل', 'پنیر موزارلا', 'پنیر پارمزان'],
        servingStyle: 'یک پرس لازانیا داغ از فر.',
        pairings: ['سالاد فصل', 'نان سیر', 'نوشیدنی سرد'],
        origin: 'ایتالیا',
        imageId: 'photo-1574894709920-11b28e7367e3',
        related: ['pasta-bolognese', 'pasta-alfredo', 'pizza-margherita', 'caesar-salad'],
    },
    {
        slug: 'pizza-margherita',
        name: 'پیتزا مارگاریتا',
        nameEn: 'Pizza Margherita',
        category: 'international',
        short: 'پیتزا کلاسیک ایتالیایی با گوجه، موزارلا و ریحان تازه.',
        description: 'پیتزا مارگاریتا ساده‌ترین و کلاسیک‌ترین نوع پیتزای ایتالیایی است. خمیر نازک، سس گوجه طبیعی، پنیر موزارلا تازه و ریحان تازه — همین‌ها کافی هستند تا پیتزایی خوش‌طعم ایجاد شود.\n\n' +
            'در آرشه، پیتزا مارگاریتا با خمیر تازه و سس گوجه خانگی تهیه می‌شود. زمان پخت در فر داغ کوتاه است تا خمیر کمی ترد و پنیر کاملاً ذوب شود.',
        ingredients: ['خمیر پیتزا', 'سس گوجه', 'پنیر موزارلا تازه', 'ریحان تازه', 'روغن زیتون'],
        servingStyle: 'پیتزا مارگاریتای ۲۴ سانتی، برش‌خورده.',
        pairings: ['سالاد فصل', 'نوشیدنی سرد', 'نان سیر'],
        origin: 'ناپل / ایتالیا',
        imageId: 'photo-1565299624946-b28f40a0ae38',
        related: ['lasagna', 'pasta-alfredo', 'pasta-bolognese', 'caesar-salad'],
    },
    {
        slug: 'caesar-salad',
        name: 'سالاد سزار با مرغ',
        nameEn: 'Caesar Salad with Chicken',
        category: 'salad',
        short: 'کاهو رومی، نان تست، پنیر پارمزان و مرغ گریل با سس سزار اصیل.',
        description: 'سالاد سزار از معروف‌ترین سالادهای دنیا است. کاهو رومی تازه، تکه‌های نان تست شده (کروتون)، پنیر پارمزان رنده‌شده، و سس سزار با ترکیب مایونز، آنچوی، سیر و لیمو، سالادی تازه و خوش‌طعم می‌سازد.\n\n' +
            'در آرشه، سالاد سزار به‌عنوان یک وعده کامل سبک ارائه می‌شود — تکه‌های سینه مرغ گریل روی آن قرار می‌گیرد. سس سزار خانگی روزانه آماده می‌شود.',
        ingredients: ['کاهو رومی', 'نان تست', 'پنیر پارمزان', 'سینه مرغ گریل', 'مایونز', 'سیر', 'لیمو', 'آنچوی'],
        servingStyle: 'یک کاسه بزرگ سالاد با مرغ گریل روی آن.',
        pairings: ['نان سیر', 'نوشیدنی سرد', 'پاستا'],
        origin: 'ایتالیایی-آمریکایی',
        imageId: 'photo-1546069901-ba9599a7e63c',
        related: ['salad-shirazi', 'salad-olviyeh', 'pasta-alfredo', 'pizza-margherita'],
    },
    {
        slug: 'salad-shirazi',
        name: 'سالاد شیرازی',
        nameEn: 'Salad Shirazi',
        category: 'salad',
        short: 'مخلوط خیار، گوجه، پیاز و نعنا با آبلیمو — همراه همیشگی غذای ایرانی.',
        description: 'سالاد شیرازی ساده‌ترین و معروف‌ترین سالاد ایرانی است. مخلوط خیار، گوجه و پیاز خرد شده با نعنای تازه، آبلیمو و کمی نمک — همین ترکیب ساده، تازگی و طراوت بی‌نظیری دارد.\n\n' +
            'در آرشه، سالاد شیرازی روزانه و تازه آماده می‌شود. این سالاد همراه با هر وعده ایرانی (کباب، خورشت، پلو) سرو می‌شود.',
        ingredients: ['خیار', 'گوجه', 'پیاز', 'نعنا تازه', 'آبلیمو', 'نمک'],
        servingStyle: 'بشقاب کوچک سالاد شیرازی در کنار غذای اصلی.',
        pairings: ['تمام غذاهای ایرانی', 'کباب', 'خورشت', 'پلو'],
        origin: 'شیراز',
        imageId: 'photo-1546069901-ba9599a7e63c',
        related: ['salad-olviyeh', 'caesar-salad', 'mast-khiar', 'sabzi-khordan'],
    },
    {
        slug: 'salad-olviyeh',
        name: 'سالاد الویه',
        nameEn: 'Salad Olviyeh',
        category: 'salad',
        short: 'سالاد سنتی با مرغ، سیب‌زمینی، تخم‌مرغ، نخود و خیارشور — انتخاب ناهار سبک.',
        description: 'سالاد الویه یکی از سالادهای محبوب در فرهنگ غذایی ایران است. ترکیب مرغ پخته خرد شده، سیب‌زمینی آب‌پز، تخم‌مرغ آب‌پز، نخود و خیارشور با سس مایونز، سالادی پروتئین‌دار و سیرکننده ایجاد می‌کند.\n\n' +
            'در آرشه، سالاد الویه به‌عنوان گزینه پروتئین‌دار سبک یا پر کردن نان ساندویچی ارائه می‌شود. مرغ تازه پخته‌شده روزانه استفاده می‌شود.',
        ingredients: ['مرغ پخته', 'سیب‌زمینی', 'تخم‌مرغ', 'نخود', 'خیارشور', 'سس مایونز', 'فلفل'],
        servingStyle: 'یک بشقاب سالاد الویه با نان بربری یا تست.',
        pairings: ['نان بربری', 'نان تست', 'نوشیدنی سرد'],
        imageId: 'photo-1546069901-ba9599a7e63c',
        related: ['salad-shirazi', 'caesar-salad', 'mast-khiar', 'mirza-ghasemi'],
    },
];
export const DISH_SLUGS = DISHES.map((d) => d.slug);
